function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 4.2434C14.4 4.2434 14 4.64804 14 5.255V8.28978H2V5.255C2 4.64804 1.6 4.2434 1 4.2434C0.4 4.2434 0 4.64804 0 5.255V9.30138C0 9.90834 0.4 10.313 1 10.313H2V11.3246C2 11.9315 2.4 12.3362 3 12.3362C3.6 12.3362 4 11.9315 4 11.3246V10.313H12V11.3246C12 11.9315 12.4 12.3362 13 12.3362C13.6 12.3362 14 11.9315 14 11.3246V10.313H15C15.6 10.313 16 9.90834 16 9.30138V5.255C16 4.64804 15.6 4.2434 15 4.2434ZM13 1.20862C13 0.60166 12.6 0.197021 12 0.197021H4C3.4 0.197021 3 0.60166 3 1.20862V7.27819H13V1.20862Z",
  fill: "#BCBCBC"
});

function SvgCatalogBtnsofaMenu({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSA0LjI0MzRDMTQuNCA0LjI0MzQgMTQgNC42NDgwNCAxNCA1LjI1NVY4LjI4OTc4SDJWNS4yNTVDMiA0LjY0ODA0IDEuNiA0LjI0MzQgMSA0LjI0MzRDMC40IDQuMjQzNCAwIDQuNjQ4MDQgMCA1LjI1NVY5LjMwMTM4QzAgOS45MDgzNCAwLjQgMTAuMzEzIDEgMTAuMzEzSDJWMTEuMzI0NkMyIDExLjkzMTUgMi40IDEyLjMzNjIgMyAxMi4zMzYyQzMuNiAxMi4zMzYyIDQgMTEuOTMxNSA0IDExLjMyNDZWMTAuMzEzSDEyVjExLjMyNDZDMTIgMTEuOTMxNSAxMi40IDEyLjMzNjIgMTMgMTIuMzM2MkMxMy42IDEyLjMzNjIgMTQgMTEuOTMxNSAxNCAxMS4zMjQ2VjEwLjMxM0gxNUMxNS42IDEwLjMxMyAxNiA5LjkwODM0IDE2IDkuMzAxMzhWNS4yNTVDMTYgNC42NDgwNCAxNS42IDQuMjQzNCAxNSA0LjI0MzRaTTEzIDEuMjA4NjJDMTMgMC42MDE2NiAxMi42IDAuMTk3MDIxIDEyIDAuMTk3MDIxSDRDMy40IDAuMTk3MDIxIDMgMC42MDE2NiAzIDEuMjA4NjJWNy4yNzgxOUgxM1YxLjIwODYyWiIgZmlsbD0iI0JDQkNCQyIvPgo8L3N2Zz4K";
export { SvgCatalogBtnsofaMenu as ReactComponent };